import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2';
import { retrieveSession, loginCanvaUser } from '../handlers/authHandler'

const CanvaRoute = ({ children }: { children: React.ReactNode }) => {
  const { canvaAuthenticated, setCanvaAuthenticated, setToken } = useCanvaAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Prevent duplicate calls in StrictMode
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const login = async () => {
      try {
        const session = searchParams.get('session');

        if (!session) {
          setCanvaAuthenticated(null);
          setIsLoading(false);
          return;
        }

        const sessionDetails = await retrieveSession(session);

        if (!sessionDetails || !sessionDetails.jwt) {
          setCanvaAuthenticated(null);
          setIsLoading(false);
          return;
        }

        const { jwt, locale } = sessionDetails

        const response = await loginCanvaUser(jwt, locale);
        if (!response) {
          setCanvaAuthenticated(null);
          setIsLoading(false);
          return;
        }

        setCanvaAuthenticated(response);
        setToken(jwt);
        setIsLoading(false);
      } catch (error) {
        console.error('[CanvaRoute] Login error:', error);
        setCanvaAuthenticated(null);
        setIsLoading(false);
      }
    };

    login();
  }, [searchParams, setCanvaAuthenticated, setToken]);

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (canvaAuthenticated) ? <>{children}</> : <Navigate to="/canva-back?error=12" />;
};

export default CanvaRoute;
